document.addEventListener('DOMContentLoaded', function() {
  // Find the product form and upsell block
  const productForm = document.querySelector('form[action*="/cart/add"]');
  const upsellBlock = document.querySelector('.product-upsell-block');
  
  if (!productForm || !upsellBlock) return;
  
  // Check metafield availability
  const hasProductMetafields = upsellBlock.dataset.hasProductMetafields === 'true';
  const hasVariantMetafields = upsellBlock.dataset.hasVariantMetafields === 'true';
  
  // Store the product ID for later use
  const productId = upsellBlock.dataset.productId;
  
  // Always setup variant change listeners if we have variant metafields
  // (even if we also have product metafields)
  if (hasVariantMetafields) {
    setupVariantChangeListeners();
  }
  
  // Initialize cart functionality for all upsell items
  initializeUpsellEvents();
  
  function setupVariantChangeListeners() {
    console.log('Setting up variant change listeners for variant metafields');
    
    // Method 1: Listen for changes on select dropdowns
    const variantSelects = productForm.querySelectorAll('select[name="id"]');
    variantSelects.forEach(select => {
      select.addEventListener('change', handleVariantChange);
    });
    
    // Method 2: Listen for changes on radio buttons
    const variantRadios = productForm.querySelectorAll('input[type="radio"][name="id"]');
    variantRadios.forEach(radio => {
      radio.addEventListener('change', handleVariantChange);
    });
    
    // Method 3: Listen for option changes
    const optionSelectors = productForm.querySelectorAll('select[name^="options["], input[name^="options["]');
    optionSelectors.forEach(selector => {
      selector.addEventListener('change', function() {
        setTimeout(() => {
          const currentVariantId = getCurrentVariantId();
          if (currentVariantId) {
            fetchUpdatedVariantUpsells(currentVariantId);
          }
        }, 100);
      });
    });
    
    // Method 4: Listen for custom variant change events
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        fetchUpdatedVariantUpsells(event.detail.variant.id);
      }
    });
    
    // Method 5: Listen for URL changes
    let lastUrl = location.href; 
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        const variantId = getVariantIdFromUrl();
        if (variantId) {
          fetchUpdatedVariantUpsells(variantId);
        }
      }
    }).observe(document, {subtree: true, childList: true});
  }
  
  function getCurrentVariantId() {
    // Try multiple methods to get the current variant ID
    const variantSelect = productForm.querySelector('select[name="id"]');
    if (variantSelect && variantSelect.value) {
      return variantSelect.value;
    }
    
    const variantRadio = productForm.querySelector('input[name="id"]:checked');
    if (variantRadio && variantRadio.value) {
      return variantRadio.value;
    }
    
    const urlVariantId = getVariantIdFromUrl();
    if (urlVariantId) {
      return urlVariantId;
    }
    
    return upsellBlock.dataset.currentVariant;
  }
  
  function handleVariantChange(event) {
    const variantId = event.target.value;
    if (variantId) {
      fetchUpdatedVariantUpsells(variantId);
    }
  }
  
  function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
  }
  
  function fetchUpdatedVariantUpsells(variantId) {
    // Show loading state only for variant upsells
    showVariantUpsellsLoadingState();
    
    // Create the URL for fetching updated variant upsells
    const productHandle = getProductHandle();
    const url = `/products/${productHandle}?view=variant-upsells&variant=${variantId}`;
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        // Update only the variant upsells section
        updateVariantUpsellsHTML(html);
        
        // Update current variant ID
        upsellBlock.dataset.currentVariant = variantId;
      })
      .catch(error => {
        console.error('Error fetching updated variant upsells:', error);
        // Clear variant upsells on error
        clearVariantUpsells();
      })
      .finally(() => {
        removeVariantUpsellsLoadingState();
      });
  }
  
  function updateVariantUpsellsHTML(html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const newVariantUpsells = doc.querySelector('.variant-upsells-container');
    const currentVariantUpsells = document.querySelector('.variant-upsells-container');
    
    if (newVariantUpsells && currentVariantUpsells) {
      // Replace only the variant upsells container
      currentVariantUpsells.innerHTML = newVariantUpsells.innerHTML;
      
      // Re-initialize event listeners for new variant upsells
      initializeUpsellEvents();
    } else if (currentVariantUpsells) {
      // Clear variant upsells if none found
      currentVariantUpsells.innerHTML = '';
      updateTotalPrice();
      updateAddToCartButtonText();
    }
  }
  
  function clearVariantUpsells() {
    const variantUpsellsContainer = document.querySelector('.variant-upsells-container');
    if (variantUpsellsContainer) {
      variantUpsellsContainer.innerHTML = '';
      updateTotalPrice();
      updateAddToCartButtonText();
    }
  }
  
  function initializeUpsellEvents() {
    // Update total price when checkboxes change
    const checkboxes = document.querySelectorAll('.product-upsell-block .product-checkbox');
    checkboxes.forEach(checkbox => {
      // Remove existing listeners to prevent duplicates
      checkbox.removeEventListener('change', handleCheckboxChange);
      checkbox.addEventListener('change', handleCheckboxChange);
    });
    
    // Handle add to cart button
    const addButton = document.querySelector('.product-upsell-block .add-upsell-to-cart');
    if (addButton) {
      // Remove existing event listeners to prevent duplicates
      addButton.replaceWith(addButton.cloneNode(true));
      const newAddButton = document.querySelector('.product-upsell-block .add-upsell-to-cart');
      newAddButton.addEventListener('click', addSelectedToCart);
    }
    
    // Initialize the total price and button text
    updateTotalPrice();
    updateAddToCartButtonText();
  }
  
  function handleCheckboxChange() {
    updateTotalPrice();
    updateAddToCartButtonText();
  }
  
  function updateTotalPrice() {
    const checkboxes = document.querySelectorAll('.product-upsell-block .product-checkbox:checked');
    let total = 0;
    
    checkboxes.forEach(checkbox => {
      const price = parseFloat(checkbox.dataset.price);
      if (!isNaN(price)) {
        total += price;
      }
    });
    
    const totalPriceElement = document.querySelector('.product-upsell-block .upsell__total--price');
    if (totalPriceElement) {
      totalPriceElement.textContent = formatMoney(total * 100);
    }
  }
  
  function updateAddToCartButtonText() {
    const checkboxes = document.querySelectorAll('.product-upsell-block .product-checkbox:checked');
    const addTextElement = document.querySelector('.product-upsell-block .add-text');
    
    if (addTextElement) {
      const checkedCount = checkboxes.length;
      if (checkedCount > 1) {
        addTextElement.textContent = `Add both to cart`;
      } else if (checkedCount === 1) {
        addTextElement.textContent = 'Add to cart';
      } else {
        addTextElement.textContent = 'Select items';
      }
    }
  }
  
  function addSelectedToCart() {
    const checkboxes = document.querySelectorAll('.product-upsell-block .product-checkbox:checked');
    const items = [];
    
    checkboxes.forEach(checkbox => {
      items.push({
        id: parseInt(checkbox.dataset.variantId),
        quantity: 1
      });
    });
    
    if (items.length === 0) {
      alert('Please select at least one item to add to cart.');
      return;
    }
    
    // Show loading state on the button
    const addButton = document.querySelector('.add-upsell-to-cart');
    const originalButtonHTML = addButton.innerHTML;
    addButton.innerHTML = 'Adding...';
    addButton.disabled = true;
    
    // Add items to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    })
    .then(response => response.json())
    .then(data => {
      // Update cart drawer
      updateCartDrawer();
      
      // Show success state
      addButton.innerHTML = 'Added!';
      
      // Reset button state after delay
      setTimeout(() => {
        addButton.innerHTML = originalButtonHTML;
        addButton.disabled = false;
      }, 2000);
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
      addButton.innerHTML = originalButtonHTML;
      addButton.disabled = false;
      alert('Error adding items to cart. Please try again.');
    });
  }
  
  function showVariantUpsellsLoadingState() {
    const variantUpsellsContainer = document.querySelector('.variant-upsells-container');
    if (variantUpsellsContainer) {
      variantUpsellsContainer.style.opacity = '0.5';
      variantUpsellsContainer.style.pointerEvents = 'none';
    }
  }
  
  function removeVariantUpsellsLoadingState() {
    const variantUpsellsContainer = document.querySelector('.variant-upsells-container');
    if (variantUpsellsContainer) {
      variantUpsellsContainer.style.opacity = '1';
      variantUpsellsContainer.style.pointerEvents = 'auto';
    }
  }
  
  function updateCartDrawer() {
    // Generic cart drawer update logic
    const cartDrawerTrigger = document.querySelector('[data-cart-drawer-toggle]') || 
                             document.querySelector('.cart-drawer-trigger') ||
                             document.querySelector('.cart-icon-link') ||
                             document.querySelector('[data-drawer-trigger="cart"]');
    
    if (cartDrawerTrigger) {
      cartDrawerTrigger.click();
    } else {
      document.dispatchEvent(new CustomEvent('cart:updated'));
      
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
          cartCountElements.forEach(element => {
            element.textContent = cart.item_count;
          });
        });
    }
  }
  
  function getProductHandle() {
    const pathParts = window.location.pathname.split('/');
    const productsIndex = pathParts.indexOf('products');
    return productsIndex !== -1 && pathParts.length > productsIndex + 1 ? pathParts[productsIndex + 1] : '';
  }
  
  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }
});